import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoginResponse } from '../interfaces/login';
import { environment } from '../../environments/environment';
import { HtmlService } from './htmlservice';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private baseUrl = environment.baseUrl;
  private urlLogin = this.baseUrl + "/api/Login/login";

  constructor(private http: HttpClient, private htmlService: HtmlService) { }

  login(email: string, password: string): Observable<LoginResponse>{

    let headers = this.htmlService.getAnonymousHeaders();
    let body =
    {
      "email": email,
      "password": password
    };

    let result = this.http.post<any>(this.urlLogin, body, {headers});

    return result;
  }
}
